var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('brand-recently-viewed',{attrs:{"brand":_vm.brand,"decorator":_vm.excludeCurrentItem,"repository":_vm.repository}})}
var staticRenderFns = []

export { render, staticRenderFns }